// Simulated auth hook — replace with real logic later
export default function useAuth() {
  return {
    user: {
      name: 'Barakat',
      role: 'superadmin' // Change to 'tenantAdmin' or 'viewer' as needed
    }
  };
}
